export default __webpack_public_path__ + "static/media/PIX.62ecc2d5.svg";